import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import LookupsAPI from "../../API/lookups.api";

import ModelVersionsAPI from "../../API/modelVersions.api";
import { SuccessAlert } from "../../utils/Alerts";
import { getCorrectionChanges } from "../../utils/BiasCorrectionsHelpers";
import BiasCorrectionForm from "../BiasCorrectionSteps/BiasCorrectionForm";
import BaseModal from "./BaseModal";

const BiasCorrection = ({ isVisible, setIsVisible, modelId }) => {
    // //Form Data
    const [addedCorrections, setAddedCorrections] = useState([]);

    // //Pre-existing corrections
    const [referenceCorrections, setReferenceCorrections] = useState({});

    // //General States
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        if (modelId) {
            getBiasCorrections();
        }
    }, [modelId]);

    const submitCorrections = async () => {
        setIsSubmitting(true);
        const result = await ModelVersionsAPI.updateBiasCorrection(
            getPayload()
        );
        if (result.modified) {
            setReferenceCorrections(updateCorrectionChanges());
            setAddedCorrections((prevCorrections) =>
                prevCorrections.filter((correction) => !correction.isDeleted)
            );
            SuccessAlert("Modified Successfully");
            setIsVisible(false);
        }
        setIsSubmitting(false);
    };

    const getBiasCorrections = async () => {
        const result = await LookupsAPI.getBiasCorrections(modelId);
        setAddedCorrections(result);
        //Dictionary used as reference to already existing corrections
        const reference = {};
        setReferenceCorrections(() => {
            result.forEach((correction) => {
                reference[correction.value] = correction;
            });
            return reference;
        });
    };

    const getPayload = () => {
        return {
            modelParameterVersionId: modelId,
            biasCorrections: getCorrectionChanges(
                addedCorrections,
                referenceCorrections
            ),
        };
    };

    const updateCorrectionsReducer = (accum, correction) => {
        if (!correction.isDeleted) {
            return { ...accum, [correction.value]: correction };
        }
        return accum;
    };

    const updateCorrectionChanges = () => {
        return {
            ...referenceCorrections,
            ...addedCorrections?.reduce(updateCorrectionsReducer, {}),
        };
    };

    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            isSubmitting={isSubmitting}
            title={t("biasCorrection")}
            titleIcon="fas fa-cog"
            action={{
                name: t("save"),
                submitAction: submitCorrections,
                disabled:
                    getPayload()?.biasCorrections?.length < 1 || isSubmitting,
            }}
            submitAction={submitCorrections}
        >
            <BiasCorrectionForm
                modelId={modelId}
                isVisible={isVisible}
                addedCorrections={addedCorrections}
                setAddedCorrections={setAddedCorrections}
                referenceCorrections={referenceCorrections}
            />
        </BaseModal>
    );
};

export default BiasCorrection;
